import { logMessage } from './externalMethods';

const logger = (type, logPayload) => {
    const getTimestamp = () => {
        const date = new Date();
        return `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()}`;
    };

    if (logPayload) {
        try {
            let log = [];

            const currentState = sessionStorage.getItem('SPOTLIGHT_LOGGER');
            if (currentState) {
                const parsed = JSON.parse(currentState);
                if (Array.isArray(parsed)) {
                    log = parsed;
                } else {
                    // if the parsed value is not an array, clear it and start fresh
                    sessionStorage.removeItem('SPOTLIGHT_LOGGER');
                }
            }

            const newEntry = {
                timestamp: getTimestamp(),
                type,
                ...logPayload,
            };

            log.push(newEntry);

            if (log.length > 100) {
                log = log.slice(-100);
            }

            logMessage(type, logPayload);
            sessionStorage.setItem('SPOTLIGHT_LOGGER', JSON.stringify(log));
        } catch (err) {
            // fallback in case JSON.parse fails (e.g. malformed JSON)
            sessionStorage.removeItem('SPOTLIGHT_LOGGER');
        }
    }
};

export default logger;
